// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rc-c";
export var backButton = "_rc-4";
export var backIcon = "_rc-5";
export var chevronShortcut = "_rc-6";
export var container = "_rc-1";
export var editor = "_rc-8";
export var editorWrapper = "_rc-7";
export var prefix = "_rc-2";
export var searchIcon = "_rc-3";
export var suffix = "_rc-9";
export var suffixContent = "_rc-a";
export var suffixText = "_rc-b";
export var wrapper = "_rc-0";